import { Navigate, Route } from "react-router-dom";
import { useSelector } from "react-redux";

import CharacterPage from "./pages/CharacterPage/CharacterPage";
import CharactersPage from "./pages/CharactersPage/CharactersPage";
import InventoryPage from "./pages/InventoryPage/InventoryPage";
import JournalPage from "./pages/JournalPage/JournalPage";
import { LoginPage } from "./pages/LoginPage";
import MainPage from "./pages/Home/MainPage";
import ProfilePage from "./pages/ProfilePage";
import { RegistrationPage } from "./pages/RegistrationPage";
import SpellsPage from "./pages/SpellsPage/SpellsPage";
import AdminPage from "./pages/AdminPage/AdminPage";
import CampaignsPage from "./pages/CampaignsPage/CampaignsPage";
import CampaignPage from "./pages/CampaignsPage/CampaignPage";
import EncounterPage from "./pages/CampaignsPage/EncounterPage";

const CharacterRoute = ({ children }) => {
  const selectedCharacterId = useSelector(
    (state) => state.character.selectedCharacterId
  );

  return selectedCharacterId ? children : <Navigate to="/characters" replace />;
};

export function getRoutesByAuth(isAuthenticated, user) {
  if (!isAuthenticated || user === null || user === undefined) {
    return (
      <>
        <Route path="/auth/login" element={<LoginPage />} />
        <Route path="/auth/signup" element={<RegistrationPage />} />
        <Route path="/*" element={<Navigate to="/auth/login" />} />
      </>
    );
  }

  return (
    <Route path="/" element={<MainPage />}>
      <Route index element={<Navigate to="/characters" replace />} />
      <Route path="characters" element={<CharactersPage />} />
      <Route path="campaigns" element={<CampaignsPage />} />
      <Route path="campaigns/:campaignId" element={<CampaignPage />} />
      <Route path="campaigns/:campaignId/encounters/:encounterId" element={<EncounterPage />} />
      <Route path="profile" element={<ProfilePage />} />
      <Route path="admin" element={user.roles?.includes("ADMIN") ? <AdminPage /> : <Navigate to="/characters" replace />} />
      <Route
        path="character"
        element={
          <CharacterRoute>
            <CharacterPage />
          </CharacterRoute>
        }
      />
      <Route
        path="journal"
        element={
          <CharacterRoute>
            <JournalPage />
          </CharacterRoute>
        }
      />
      <Route
        path="spells"
        element={
          <CharacterRoute>
            <SpellsPage />
          </CharacterRoute>
        }
      />
      <Route
        path="inventory"
        element={
          <CharacterRoute>
            <InventoryPage />
          </CharacterRoute>
        }
      />
      <Route path="*" element={<Navigate to="/characters" replace />} />
    </Route>
  );
}
